module.exports = __webpack_public_path__ + "img/how_to_program_splash.6e05dfcb.jpg";